import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { from, Observable, of } from 'rxjs';
import { catchError, concatMap, finalize, map, take, toArray } from 'rxjs/operators';
import { ChallengeProcessingService, ProcessingOptions, ProcessingRow } from './challenge-processing.service';

@Component({selector: 'app-reprocess-challenge-modal', templateUrl: './reprocess-challenge-modal.component.html',
    styles: [':host{display:block}fieldset{border:0;padding:0}label{display:block;margin:12px 0}textarea{width:100%}table{width:100%}th,td{text-align:left;vertical-align:top;padding:10px;border-bottom:1px solid #ddd}.processing-table{overflow-x:auto}.detail{display:block;font-size:12px;margin-top:4px}progress{width:100%}']})
export class ReprocessChallengeModalComponent implements DwModalHandler, OnInit {
    modalConfig: DwModalConfig<{challengeIds: number[]}>; closeModal: EventEmitter<DwModalResult>;
    rows: ProcessingRow[] = []; loading = true; busy = false; completed = false; error = '';
    options: ProcessingOptions = {reason: '', reviseFinals: false, provision: false};
    get completedCount(): number { return this.rows.filter(row => row.state === 'completed' || row.state === 'failed').length; }
    constructor(private _processing: ChallengeProcessingService) {}
    ngOnInit(): void {
        this._processing.candidates().pipe(take(1), finalize(() => this.loading = false)).subscribe(candidates => {
            const ids = this.modalConfig.data.challengeIds;
            if (ids.some(id => !candidates.some(candidate => candidate.ChallengeDefinitionId === id))) { this.error = 'Some selected challenges are unavailable. Reload the grid and try again.'; return; }
            this.rows = ids.map(id => ({challenge: candidates.find(candidate => candidate.ChallengeDefinitionId === id),
                operationId: this._processing.operationId(), state: 'waiting'}));
        }, () => this.error = 'Unable to load processing status. Close this dialog and try again.');
    }
    buttonClick(button: DwButtonConfig): Observable<DwModalResult> {
        const result = new DwModalResult(); result.buttonCommand = button.command; result.closeModal = false; result.cancelled = true;
        if (this.busy) { return of(result); }
        if (button.command !== DwButtonCommand.saveAndClose) {
            result.closeModal = true; result.cancelled = !this.completed; result.data = this.completed ? this.rows : undefined; return of(result);
        }
        if (this.completed || this.loading) { return of(result); }
        if (!this.rows.length || !this.options.reason.trim() || this.options.reason.trim().length > 500) {
            this.error = 'Enter a reason of 1–500 characters before processing.'; return of(result);
        }
        this.busy = true; this.error = '';
        const options = {...this.options};
        return from(this.rows).pipe(concatMap(row => this._processing.process(row, options).pipe(catchError(error => {
            row.state = 'failed';
            row.message = error?.error?.type === 'urn:fitness:award-operation-incomplete'
                ? 'An incomplete award operation needs administrator review. Do not restart it without checking the maintenance log.'
                : (error?.error?.title || error?.error?.Title || (error?.status ? 'HTTP ' + error.status + ': processing was not confirmed.' : error?.message) || 'Processing was not confirmed.')
                    + ' Check this challenge and operation in the maintenance log before retrying.';
            return of(row);
        }))), toArray(), map(() => {
            this.completed = true;
            this.modalConfig.buttons.forEach(button => {
                if (button.command === DwButtonCommand.saveAndClose) { button.disabled = true; }
                else { button.buttonText = 'Close'; button.useParentDisplay = false; }
            });
            // Keep per-challenge outcomes visible until the administrator closes the modal.
            return result;
        }), finalize(() => this.busy = false));
    }
}
